<div *ngIf="isLoading" style="margin-top: 10px;">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<mat-card>
  <h3>B2B Invoice {{invoice?.invoiceNumber}}</h3>
  <ng-container *ngIf="invoice">
    <div>for {{invoice.company.name}}</div>
    <div>of {{invoice.invoiceDate | date : 'yyyy-MM-dd' }} <span style="font-size: .8em;">(created {{invoice.createDate | date : 'yyyy-MM-dd'}})</span></div>
    <div>
      <span *ngIf="invoice.invoicePeriodFrom">from {{ invoice.invoicePeriodFrom | date : 'yyyy-MM-dd' }}</span>
      <span *ngIf="invoice.invoicePeriodTo"> to {{ invoice.invoicePeriodTo | date : 'yyyy-MM-dd' }}</span>
    </div>
  </ng-container>

  <br />

  <div fxLayout="row" fxLayoutGap="10px">
    <div fxFlex="40">
      <button mat-raised-button color="default" class="mr-1" (click)="goBack()">Back</button>
    </div>
    <div fxFlex></div>
    <div fxFlex="60" style="text-align: right;">
      <mat-checkbox [disabled]="isLoading"  class="mr-1" [checked]="invoice?.isFinished"> Invoice finished</mat-checkbox>
      <mat-checkbox [disabled]="isLoading"  class="mr-1" [checked]="invoice?.isFinished"> Invoice paid</mat-checkbox>
      <button [disabled]="isLoading" mat-raised-button color="warn" class="mr-1" (click)="deleteInvoice()">Delete Invoice</button>
      <button [disabled]="isLoading" mat-raised-button class="mr-1" color="blue" (click)="updateInvoice()">Save</button>
      <button [disabled]="isLoading" mat-raised-button color="blue" (click)="downloadInvoicePdf()">Download PDF</button>
    </div>

  </div>

  <h5>Invoice Items</h5>


  <ng-container *ngIf="invoiceLineItems">
    <table mat-table [dataSource]="invoiceLineItems" #invoiceTable>

      <ng-container matColumnDef="del">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="lineItemCodes">
            <mat-icon style="cursor: pointer;" (click)="deleteItemFromInvoice(element)">delete</mat-icon>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef> Code </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="lineItemCodes">
            <mat-select [(ngModel)]="element.code">
              <mat-option [value]="">(other)</mat-option>
              <mat-option *ngFor="let lineItemCode of lineItemCodes" [value]="lineItemCode">{{ lineItemCode }}</mat-option>
            </mat-select>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Description </th>
        <td mat-cell *matCellDef="let element">
          <input matInput [(ngModel)]="element.description" style="width: 100%" />
        </td>
      </ng-container>

      <ng-container matColumnDef="currency">
        <th mat-header-cell *matHeaderCellDef> Currency </th>
        <td mat-cell *matCellDef="let element">
          <mat-select [(ngModel)]="element.currencyCode">
            <mat-option [value]="978">EUR</mat-option>
            <mat-option [value]="826">GBP</mat-option>

          </mat-select>
        </td>
      </ng-container>

      <ng-container matColumnDef="numberOfItems">
        <th mat-header-cell *matHeaderCellDef> Number </th>
        <td mat-cell *matCellDef="let element">
          <input matInput [(ngModel)]="element.numberOfItems" style="text-align: right;" [class]="element.needsUserInput ? 'needs-input':''" /></td>
      </ng-container>

      <ng-container matColumnDef="netAmountPerItem">
        <th mat-header-cell *matHeaderCellDef> Net / Item </th>
        <td mat-cell *matCellDef="let element" class="text-right"> <input matInput [(ngModel)]="element.netAmountPerItem" style="text-align: right;" [class]="element.needsUserInput ? 'needs-input':''" /> </td>
      </ng-container>

      <ng-container matColumnDef="netTotal">
        <th mat-header-cell *matHeaderCellDef class="text-right"> Net Total </th>
        <td mat-cell *matCellDef="let element" class="text-right">
              <span [style]="(element.netAmountPerItem * element.numberOfItems) < 0 ? 'color: red;' : ''">
              {{ (element.netAmountPerItem * element.numberOfItems) | number: '1.2-2' }}
              </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
  </ng-container>

  <div class="text-right">
    <button class="mr-1" mat-raised-button color="primary" (click)="addItemToInvoice()">Add Invoice item</button>
  </div>



  <h5>Commission Items</h5>
  <ng-container *ngIf="commissionLineItems">
    <table mat-table [dataSource]="commissionLineItems" #commissionTable>

      <ng-container matColumnDef="del">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="lineItemCodes">
            <mat-icon style="cursor: pointer;" (click)="deleteItemFromInvoice(element)">delete</mat-icon>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef> Code </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="lineItemCodes">
            <mat-select [(ngModel)]="element.code">
              <mat-option [value]="">(other)</mat-option>
              <mat-option *ngFor="let lineItemCode of lineItemCodes" [value]="lineItemCode">{{ lineItemCode }}</mat-option>
            </mat-select>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Description </th>
        <td mat-cell *matCellDef="let element">
          <input matInput [(ngModel)]="element.description" style="width: 100%" />
        </td>
      </ng-container>

      <ng-container matColumnDef="currency">
        <th mat-header-cell *matHeaderCellDef> Currency </th>
        <td mat-cell *matCellDef="let element">
          <mat-select [(ngModel)]="element.currencyCode">
            <mat-option [value]="978">EUR</mat-option>
            <mat-option [value]="826">GBP</mat-option>

          </mat-select>
        </td>
      </ng-container>

      <ng-container matColumnDef="numberOfItems">
        <th mat-header-cell *matHeaderCellDef> Number </th>
        <td mat-cell *matCellDef="let element">
          <input matInput [(ngModel)]="element.numberOfItems" style="text-align: right;" [class]="element.needsUserInput ? 'needs-input':''" /></td>
      </ng-container>

      <ng-container matColumnDef="netAmountPerItem">
        <th mat-header-cell *matHeaderCellDef> Net / Item </th>
        <td mat-cell *matCellDef="let element" class="text-right"> <input matInput [(ngModel)]="element.netAmountPerItem" style="text-align: right;" [class]="element.needsUserInput ? 'needs-input':''" /> </td>
      </ng-container>

      <ng-container matColumnDef="netTotal">
        <th mat-header-cell *matHeaderCellDef class="text-right"> Net Total </th>
        <td mat-cell *matCellDef="let element" class="text-right">
              <span [style]="(element.netAmountPerItem * element.numberOfItems) < 0 ? 'color: red;' : ''">
              {{ (element.netAmountPerItem * element.numberOfItems) | number: '1.2-2' }}
              </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <div class="text-right">
      <button class="mr-1" mat-raised-button color="primary" (click)="addItemToCommission()">Add Commission item</button>
    </div>

  </ng-container>


</mat-card>
